import styled from "styled-components";

import { Z_INDEX } from "app/pages/sales-intelligence/constants/common";

export const StyledZeroBlock = styled.div`
    position: absolute;
    top: 0;
    left: 0;
`;

export const StyledEmptyContainer = styled.div<{ isFloat: boolean; width?: number; height?: number }>`
    display: ${({ isFloat }) => (isFloat ? "block" : "none")};
    width: ${({ width }) => width}px;
    height: ${({ height }) => height}px;
`;

export const StyledChildContainer = styled.div<{
    isFloat: boolean;
    position: "absolute" | "fixed";
    top?: number;
    left?: number;
}>`
    top: ${({ isFloat, top }) => (isFloat && top !== undefined ? `${top}px` : "unset")};
    left: ${({ isFloat, left }) => (isFloat && left !== undefined ? `${left}px` : "unset")};
    position: ${({ isFloat, position }) => (isFloat ? position : "unset")};
    z-index: ${({ isFloat }) => (isFloat ? Z_INDEX.dropdown : "unset")};
`;
